import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  Table,
} from "reactstrap";
import { connect } from "react-redux";
import { profilePicValidityCheck } from "../../../../utils/constants";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import { toastContainer } from "../../../../utils/toast";
import * as actionCreators from "../../../../modules/actions";
import { BiDownload } from 'react-icons/bi';
import moment from "moment";

const SendSMSTextQuestionsModal = ({
  open,
  onClose,
  trivia,
  user,
  orgChangeSuccess,
  editCurrentTriviaShareData,
  smsUsersData,
  setUsersChanged,
setSmsUsersData
,usersChanged,
listingType,
trivvyResults,
setTrivvyResults
}) => {
  const [sendToDroppedUsers, setSendToDroppedUsers] = useState(null);
console.log('***smsUsersData', smsUsersData)
  const [showDroppedUsersAlert, setShowDroppedUsersAlert] = useState(false);

  // const allUsersTakenTrivvy=()=>{
  //   if(trivvyResults && trivvyResults.length){
  //      const trivvyResultUsersIds = trivvyResults.map(x => x.userId ? x.userId.toString():null).filter(k => k);
      
  //      const usersTakenTrivvy = smsUsers.filter(x => x.userId && trivvyResultUsersIds.includes(x.userId.toString()));
  //      return usersTakenTrivvy.length == smsUsers.length
  //   }else{
  //     return false;
  //   }
  // }
  

 

  // const smsUsers =
  //   sendToDroppedUsers == "YES"
  //     ? trivia
  //       ? trivia.sharedWithUsers.filter((x) => x.mobileNumber)
  //       : []
  //     : trivia
  //     ? trivia.sharedWithUsers.filter((x) => x.mobileNumber && !x.smsDate)
  //     : [];

function downloadFailedNumbersCSV(jsonData) {
  var failedNumbers = Array.isArray(jsonData) ? jsonData : [];
  if (!failedNumbers.length) return;

  var headers = Object.keys(failedNumbers[0]);
  var csvRows = [
    headers.join(","),
    ...failedNumbers.map(function (row) {
      return headers.map(function (field) {
        var v = row[field];
        return JSON.stringify(v == null ? "" : v);
      }).join(",");
    })
  ];

  var blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
  var url = URL.createObjectURL(blob);
  var link = document.createElement("a");
  link.href = url;
  link.download = "failedNumbers.csv";
  link.click();
  URL.revokeObjectURL(url);
}

  const remainingSMSLimit =
    user && user.profile && user.profile.organizationId
      ? user.profile.organizationId.smsLimit -
        user.profile.organizationId.totalSmsSent
      : 0;

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const ToastStyles = {
    PRIMARY: { backgroundColor: "#007bff", color: "white" },
    SUCCESS: { backgroundColor: "#28a745", color: "white" },
    ERROR: { backgroundColor: "#dc3545", color: "white" },
    WARNING: { backgroundColor: "#ffc107", color: "black" },
  };  

  const sendQuestionsAsTexts = () => {
    axios
      .post(url.shareTriviaAsTextSurvey, {
        triviaId: trivia._id,
        sendToDroppedUsers: sendToDroppedUsers === "YES",
        shareMediums: ["SMS"],
      })
      .then(({ data }) => {
        console.log('here i am 1',data)
        // editCurrentTriviaShareData({
        //   sharedWithUsers: data.data.updateTriviaShareUsers,
        //   privacy:trivia.privacy
        // });
        console.log("here i am 2");
        const count = data.data && data.data.smsSentCount ? data.data.smsSentCount : 0;
        toastContainer(`${count} SMS  ${count > 1 ? "texts have" : "text has"} been sent successfully.` ,"success");
        orgChangeSuccess({
          totalSmsSent: count,
        });
        onClose &&  onClose();
      })
      .catch((error) => { 
        // toastContainer("Error while sending", "error");
        console.log(error,'error')

 if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.message
        ) {

          const errorData = error.response.data.errors;

          if (errorData) {
            const smsSentCount = errorData.smsSentCount ? errorData.smsSentCount : 0;
            const failedNumbers = errorData.failedNumbers ? errorData.failedNumbers : [];
            const smsErrorCount = failedNumbers.length;
            const isOptOutError = failedNumbers.some(
              n => n.error === "Attempt to send to unsubscribed recipient"
            );
            let errorMessage = `${smsSentCount} SMS texts have been sent successfully. ${smsErrorCount} failed to send ${isOptOutError ? 'due to user opting out' : ''}`;

            if (smsErrorCount > 0 && smsErrorCount <= 5) {
              const failedList = failedNumbers.map(n => n.phoneNumber).join(', ');
              errorMessage += `: ${failedList}.`;
            } else {
              errorMessage += '.';
            }   
            showErrorToastWithDownload(errorMessage, failedNumbers); 
          } else {
             toastContainer(error.response.data.errors.message, "error");
          }   
        }
      });
  };

    const showErrorToastWithDownload = (errorMessage, failedNumbers) => {
    
    const ToastContent = () => (
      <div className="d-flex align-items-center justify-content-between w-100">
        <span style={{ flex: 1, marginRight: '5px' }}>{errorMessage}</span>
        <button
          onClick={(e) => {
            e.stopPropagation();
            downloadFailedNumbersCSV(failedNumbers);
          }}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '5px',
            display: 'flex',
            alignItems: 'center',
            color: 'white'
          }}
          title="Download failed numbers CSV"
        >
          <BiDownload size={20} />
        </button>
      </div>
    );

    toastContainer(<ToastContent />, "error", {
      closeButton: true
    });
  };

  const handleSmsCount = async () => {
    try {

      const response = await axios.get(
        `${url.getSmsUserCountForTrivia(trivia._id)}?sendToDroppedUsers=YES`
      );

      const data = response &&response.data && response.data.data || {};
      console.log(data,'ata')

      // Set the count in state
      setSmsUsersData((prev) => ({
        ...prev,
        count: data.smsUserCount,
        allUsersTakenTrivvy: data.allUsersTakenTrivvy,
        smsUserCount: data.smsUserCount,
        pendingUsersToRespond: data.pendingUsersToRespond,
        alreadySentMobilesCount: data.alreadySentMobilesCount,
        alreadySentMobiles: data.alreadySentMobiles || [],
      }));


      // Based on whether any dropped users exist
      if (data.alreadySentMobilesCount > 0) {
        console.log("setign it here");
        setShowDroppedUsersAlert(true);
        setSendToDroppedUsers("YES");
      } else {
        setSendToDroppedUsers("NO");
      }
    } catch (error) {
      console.error("❌ Error fetching SMS user count:", error);
    }
  };

function downloadFailedNumbersCSV(jsonData) {
  var failedNumbers = Array.isArray(jsonData) ? jsonData : [];
  if (!failedNumbers.length) return;

  var headers = Object.keys(failedNumbers[0]);
  var csvRows = [
    headers.join(","),
    ...failedNumbers.map(function (row) {
      return headers.map(function (field) {
        var v = row[field];
        return JSON.stringify(v == null ? "" : v);
      }).join(",");
    })
  ];

  var blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
  var url = URL.createObjectURL(blob);
  var link = document.createElement("a");
  link.href = url;
  link.download = "failedNumbers.csv";
  link.click();
  URL.revokeObjectURL(url);
}

  console.log(showDroppedUsersAlert,'showalert')
  console.log(sendToDroppedUsers,'sentodrouse')

  console.log(smsUsersData.smsUserCount &&
    !smsUsersData.allUsersTakenTrivvy &&
    smsUsersData.alreadySentMobilesCount > 1 ,'cod')
  console.log(smsUsersData.smsUserCount, "smsUsersData.smsUserCount");
  console.log(
      !smsUsersData.allUsersTakenTrivvy,
      "!smsUsersData.allUsersTakenTrivvy"
    );
  console.log(
      smsUsersData.alreadySentMobilesCount > 1,
      "smsUsersData.alreadySentMobilesCount > 1"
    );
    
    const pendingUsersToRespond = smsUsersData.pendingUsersToRespond != null ? smsUsersData.pendingUsersToRespond : 0;
    const countNotSubmitted = smsUsersData.smsUsers.filter((u) => u.isSubmitted === false && (u.smsDate === null || u.smsDate === undefined)).length;
    const countUsersToResend = pendingUsersToRespond - countNotSubmitted;
    const countPendingUsersToRespond = (sendToDroppedUsers === "YES" ? pendingUsersToRespond  : pendingUsersToRespond - countUsersToResend);

      const noOfSMSToBeSent = trivia
    ? countPendingUsersToRespond * trivia.questions.length
    : 0;

    const userLabel = countPendingUsersToRespond > 1 ? "users" : "user";
    const verbLabel = countPendingUsersToRespond > 1 ? "have" : "has";

    const hasScheduledDate = trivia && trivia.scheduledDate ? true : false;
    const isScheduledDateInPast = hasScheduledDate && moment().isAfter(moment(trivia.scheduledDate));
    const isScheduledAndPending = hasScheduledDate && !isScheduledDateInPast;

  return (
    <div>
      {smsUsersData.count ? (
        <div>
          {remainingSMSLimit <= noOfSMSToBeSent ? (
            <Alert color="error">
              You dont have sufficient SMS balance to send Trivvy questions as
              text
            </Alert>
          ) : (
            <div></div>
          )}
        </div>
      ) : (
        ""
      )}

      {smsUsersData.count > 0 && sendToDroppedUsers != null && (
        <Alert>
          {
            countPendingUsersToRespond === 0 ? "All users have completed this Trivvy." : `${countPendingUsersToRespond} ${userLabel} who ${verbLabel} not completed yet, will receive the Trivvy as SMS Text(s).` 
          }
          <br />
          {
            countPendingUsersToRespond > 0 && `Total ${noOfSMSToBeSent} SMS texts (1 text per question) will be sent.`
          }
          <div className="d-flex mt-3">
            <Button
              color="success"
              onClick={() => {
                setSendToDroppedUsers(null);
                sendQuestionsAsTexts();
              }}
              disabled={
                isScheduledAndPending ||
                remainingSMSLimit < noOfSMSToBeSent ||
                (smsUsersData.smsUserCount &&
                  !smsUsersData.allUsersTakenTrivvy &&
                  countUsersToResend > 0 &&showDroppedUsersAlert) || countPendingUsersToRespond === 0
              }
            >
              Send Trivvy
              {/* send trivvy dude */}
            </Button>{" "}
            <Button
              color="danger"
              className="ml-3"
              onClick={() => {
                setSendToDroppedUsers(null);
                setShowDroppedUsersAlert(false);                
              }}
            >
              Cancel
            </Button>
          </div>
        </Alert>
      )}

      {showDroppedUsersAlert && (
        <div>
          {smsUsersData.smsUserCount && smsUsersData.allUsersTakenTrivvy && (
            <Alert color="warning">
              This Trivvy has already been sent to the mobile number
              {smsUsersData.alreadySentMobilesCount > 1 ? "s" : ""}:
              <br />
              {smsUsersData.alreadySentMobiles.join(", ")}
            </Alert>
          )}

            {smsUsersData.smsUserCount &&
            !smsUsersData.allUsersTakenTrivvy &&
            countUsersToResend > 0 && (
              <Alert color="warning">
                {countUsersToResend} {countUsersToResend > 1 ? "people" : "person"} {countUsersToResend > 1 ? "have" : "has"} already received this Trivvy and not completed it.
                <br />
                <div className="d-flex mt-3">
                  <Button
                    color="success"
                    onClick={() => {
                      setSendToDroppedUsers("YES");
                      setShowDroppedUsersAlert(false);
                    }}
                  >
                    Re-Send again
                  </Button>{" "}
                  <Button
                    color="danger"
                    className="ml-3"
                    onClick={() => {
                      setSendToDroppedUsers("NO");
                      setShowDroppedUsersAlert(false);
                      setSmsUsersData((prev)=>({
                  ...prev,
                  count: prev.count - prev.alreadySentMobilesCount
                }))
                    }}
                  >
                    Don't resend
                  </Button>
                </div>
              </Alert>
            )}
        </div>
      )}

      <div
        className={
          usersChanged && listingType === "new"
            ? "flex justify-content-center align-items-center"
            : "flex justify-content-end align-items-center"
        }
      >
        {showDroppedUsersAlert || sendToDroppedUsers != null ? (
          ""
        ) : (
          <Button
            className="trivia-action-button-main"
            onClick={handleSmsCount}
            disabled={isScheduledAndPending || (usersChanged && listingType === "new") || (smsUsersData && smsUsersData.totalUsers === 0)}
          >
            <span style={{fontSize: "16px"}}>Share Trivvy as SMS Texts</span>
           
          </Button>
        )}

        {usersChanged && listingType === "new" ? (
          <Alert className=" mb-0 w-100" color="info">
            Please <strong>Save invited users</strong> first to Share Trivvy
            Link to them
          </Alert>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SendSMSTextQuestionsModal);
